import React, { useState } from 'react';
import { SearcherCard } from '../components/newproduct/SearcherCard.es';
import { useBetween } from 'use-between';
import { ProductList } from '../components/newproduct/ProductList';
import { useFetchCards } from '../hooks/card/useFetchCards';
import { usePaginationCard } from '../hooks/card/usePaginationCard';
import { AddProduct } from '../components/AddProduct';

export const CardScreen = () => {

    const useSharedPagination = () => useBetween(usePaginationCard);

    const { state: cards, setState: setCards } = useFetchCards();

    const useAddProductModal = () => {
        const [addProductModal, setAddProductModal] = useState({ visible: false, data: {} });
        return {
            addProductModal, setAddProductModal
        }
    }

    const useSharedAddProductModal = () => useBetween(useAddProductModal);

    return (
        <>
            <SearcherCard cards={cards} setCards={setCards} pagination={useSharedPagination} useAddProductModal={useSharedAddProductModal} />
            <ProductList cards={cards} setCards={setCards} />
            <AddProduct useAddProductModal={useSharedAddProductModal} />
        </>
    )
}